import Cookies from 'js-cookie'

import $ from "jquery";
window.$ = $;

import Selectize from "./selectize_clear.js";
import slick from "slick-carousel";

function init()
{
    $(".slider").slick({
        arrows: true,
        dots: true,
        adaptiveHeight: true
    });

    function activatePanel(panel)
    {
        document.querySelectorAll(".topic").forEach(el => {
            el.classList.toggle("active", el.id === panel);
        });
        document.querySelectorAll(".section_nav li").forEach(li => {
            const link = li.querySelector("a[data-href]");
            li.classList.toggle("active", !!link && link.dataset.href === panel);
        });
    }

    document.querySelectorAll(".section_nav a[data-href]").forEach(link => {
        link.addEventListener("click", e => {
            e.preventDefault();
            activatePanel(link.dataset.href);
        });
    });
    $(".menubutton").click(function () {
        $("body").toggleClass("body--showmenu");
    });

    function saveFilterCookies(form) {
        var sort = $('[name="Sort"]', form).val();
        var number = $('[name="Number"]', form).val();
        var compact = $('[name="CompactView"]', form).is(':checked') ? '1' : '0';
        if (sort) Cookies.set('RefSearch_Sort', sort, { expires: 365, path: '/' });
        if (number) Cookies.set('RefSearch_Number', number, { expires: 365, path: '/' });
        Cookies.set('RefSearch_CompactView', compact, { expires: 365, path: '/' });
    }

    $("#filtermenu select").change(function () {
        saveFilterCookies(this.form);
        this.form.submit();
    });

    $("#filtermenu select").each(function () {
        if ($(this).attr("name")=="Number" ||
            $(this).attr("name")=="Sort"  ||
            $(this).attr("name")=="Status" ||
            $(this).attr("name")=="IsPublic") {
            $(this).selectize({
            });
        } else {
            $(this).selectize({
                plugins: {
                    'clear_selection': {}
                },
            });
        }
    });

    $(".section_nav_select").on("change", function () {
        activatePanel(this.value);
    }).selectize();

    $('#filtermenu').on('submit', function () {
        saveFilterCookies(this);
    });

    $('#filtermenu [type="checkbox"]').change(function () {
        saveFilterCookies(this.form);
        this.form.submit();
    });
    $("#selectall").change(function () {
        if (this.checked) {
            $(".item_select input").prop('checked', true);
        } else {
            $(".item_select input").prop('checked', false);
        }
    });
    $(".deletelink").click(function (e) {
        if (!confirm("Sind Sie sicher?")) {
            e.preventDefault();
        }
    });

    //Editing

    $("#Form_EditForm_Image").change(function (event) {
        $("#Form_EditForm_Image_Preview").attr(
            "src",
            URL.createObjectURL(event.target.files[0])
        );
        $("#Form_EditForm_Image_Name").html(event.target.files[0].name);
    });

    $("#Form_EditForm_Image2").change(function (event) {
        $("#Form_EditForm_Image2_Preview").attr(
            "src",
            URL.createObjectURL(event.target.files[0])
        );
        $("#Form_EditForm_Image2_Name").html(event.target.files[0].name);
    });

    $("#addtolist").change(function () {
        $(this.form).append('<input type="hidden" name="format" value="addtolist"/>');
        this.form.target="_self";
        this.form.submit();
    }).each(function () {
        $(this).selectize();
    });

    $("#removefromlist").click(function () {
        this.form.target="_self";
    });

    const activateMaps = function () {
        $('[data-behaviour="map"]').each(function () {
            const $map = $(this);
            $map.addClass("map_container--active")
            $("iframe", $map).attr("src", $map.data("src"));
        });
        Cookies.set('maps-activated', '1', { expires: 365, path: '/' });
    }

    $('[data-behaviour="map"]').each(function () {
        const $map = $(this);
        $(".button", $map).click(function () {
            activateMaps();
        })
    });

    if(Cookies.get('maps-activated')) {
        activateMaps();
    }
}

$(init);
